module.exports = __webpack_public_path__ + "img/JAB-HOUSE-B.17b44bfd.png";